import api from "./index";

export async function sendEvent(body) {
  return api.post("/sellflux/events", body);
}
